import { memoizeWith } from 'ramda';
import { mergeStyles } from '../../../../internal/utils/mergeStyles';
import mainStyles from './styles.module.css';
import { getDeviceStyles, getDeviceStylesIdentity } from './device';
function getRadioStyles(deviceType) {
  const deviceStyles = getDeviceStyles(deviceType);
  return mergeStyles(mainStyles, deviceStyles);
}
export const getStyles = memoizeWith(getDeviceStylesIdentity, getRadioStyles);